import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './img/guan.png';
const _withScopeId = n => (_pushScopeId("data-v-6b66fc64"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "nav-header"
};
const _hoisted_2 = {
  class: "grid-box"
};
const _hoisted_3 = {
  class: "flex-group-l"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = ["src"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg-img-guan",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_9 = {
  class: "flex-group-r"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["src", "alt"];
const _hoisted_12 = ["src", "alt"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-tab"
}, null, -1));
import { useRouter } from "vue-router";
import { watch, ref } from "vue";
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const curtPageName = ref("name");
    const cityId = ref(localStorage.getItem('cityId'));
    watch(() => router.currentRoute.value, newValue => {
      if (newValue.name) {
        curtPageName.value = newValue.name;
      }
    }, {
      immediate: true
    });
    const goPage = page => {
      router.push({
        name: page
      });
    };
    const navBtnsL = [{
      label: "地区概述",
      page: "MapOverview",
      imgA: require("./img/1-a.png"),
      img: require("./img/1.png")
    }, {
      label: "农业土地",
      page: "AgriculturalLand",
      imgA: require("./img/2-a.png"),
      img: require("./img/2.png")
    }, {
      label: "人口就业",
      page: "PopulationEmployment",
      imgA: require("./img/3-a.png"),
      img: require("./img/3.png")
    }];
    const navBtnsR = [{
      label: "党政建设",
      page: "PartyPolicy",
      imgA: require("./img/4-a.png"),
      img: require("./img/4.png")
    }, {
      label: "民生保障",
      page: "PeopleLivelihood",
      imgA: require("./img/5-a.png"),
      img: require("./img/5.png")
    }, {
      label: "非遗文化",
      page: "ecology",
      imgA: require("./img/6-a.png"),
      img: require("./img/6.png")
    }];
    return (_ctx, _cache) => {
      const _component_di = _resolveComponent("di");
      return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(navBtnsL, item => {
        return _createElementVNode("div", {
          key: item.page,
          onClick: $event => goPage(item.page)
        }, [curtPageName.value === item.page ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.imgA,
          alt: item.label
        }, null, 8, _hoisted_5)) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: item.img,
          alt: item.label
        }, null, 8, _hoisted_6))], 8, _hoisted_4);
      }), 64))])]), _createVNode(_component_di, {
        onClick: _cache[0] || (_cache[0] = $event => goPage('home'))
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          class: "bg-img",
          src: cityId.value == 21921 ? require('./img/baojing.png') : require('./img/huayuan.png'),
          alt: ""
        }, null, 8, _hoisted_7), _hoisted_8]),
        _: 1
      }), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(navBtnsR, item => {
        return _createElementVNode("div", {
          key: item.page,
          onClick: $event => goPage(item.page)
        }, [curtPageName.value === item.page ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.imgA,
          alt: item.label
        }, null, 8, _hoisted_11)) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: item.img,
          alt: item.label
        }, null, 8, _hoisted_12))], 8, _hoisted_10);
      }), 64))])])]), _hoisted_13]);
    };
  }
};